import { createRouter, createWebHistory } from "vue-router"
import { useAuth } from "@/composables/auth.ts"
import { isTokenValid } from "@/util/token.ts"

const CloseCashRegister = () => import("./views/CloseCashRegister.vue")
const Login = () => import("./views/Login.vue")

const { user, token } = useAuth()

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			name: "home",
			path: "/",
			redirect: { name: "cash_register_checkout" },
		},
		{
			name: "login",
			path: "/login",
			component: Login,
		},
		{
			name: "cash_register_checkout",
			path: "/neuer-kassenabschluss",
			component: CloseCashRegister,
		},
	],
})

router.beforeEach((to) => {
	// Always allow login
	if (to.name === "login") {
		return
	}

	const hasUser = !!user.value

	if (!hasUser) {
		return { name: "login" }
	}

	console.log("User loaded from storage")

	// Proceed, if the token expires in the future
	if (!token.value || !isTokenValid(token.value)) {
		console.log("Token has expired")
		return { name: "login" }
	}

	console.log("Token is valid")
})

export default router
